import { render, staticRenderFns } from "./ExamPaperViewer.vue?vue&type=template&id=3d7a66d6&scoped=true"
import script from "./ExamPaperViewer.vue?vue&type=script&lang=js"
export * from "./ExamPaperViewer.vue?vue&type=script&lang=js"
import style0 from "./ExamPaperViewer.vue?vue&type=style&index=0&id=3d7a66d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d7a66d6",
  null
  
)

export default component.exports